import type { FC } from "react";

import styles from "./SubscribeVacancy.module.scss";
import { VacancyOfferForm } from "../../../../entities/Vacancy";

interface SubscribeVacancyProps {
    onClick?: () => void;
}

export const SubscribeVacancy: FC<SubscribeVacancyProps> = ({ onClick }) => (
    <div className={styles.form}>
        <p className={styles.formCaption}>
            Нет вакансии? <VacancyOfferForm />. Возможно, она скоро появится.
        </p>
    </div>
);
